import React from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';

import { InlineTextButton } from '../Button/Button';
import { FormattedMessage } from '../../util/reactIntl';
import { getListingCopyMenuState } from '../../util/listingCopy';
import { propTypes } from '../../util/types';
import css from './CopyListingMenuItem.module.css';

/**
 * ⋮-menu Copy row contents. Digital / Fastio content is shown disabled with
 * an always-visible note (no hover-only tooltip). Campaign, Trash, and
 * unknown types render nothing so the parent can omit the MenuItem.
 */
const CopyListingMenuItem = props => {
  const { listing, busy, menuItemClassName, testId, onCopy } = props;
  const { show, disabled } = getListingCopyMenuState(listing);
  if (!show) {
    return null;
  }

  if (disabled) {
    return (
      <div
        className={classNames(menuItemClassName, css.disabledItem)}
        data-testid={testId}
        role="group"
        aria-disabled="true"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <div className={css.label}>
          <FormattedMessage id="ManageListingCard.copyListing" />
        </div>
        <p className={css.unavailableNote}>
          <FormattedMessage id="ManageListingCard.copyListingUnavailableForContent" />
        </p>
      </div>
    );
  }

  return (
    <InlineTextButton
      rootClassName={menuItemClassName}
      disabled={busy}
      data-testid={testId}
      onClick={onCopy}
    >
      <FormattedMessage id="ManageListingCard.copyListing" />
    </InlineTextButton>
  );
};

CopyListingMenuItem.defaultProps = {
  listing: null,
  busy: false,
  menuItemClassName: null,
  testId: 'listing-card-copy',
  onCopy: null,
};

CopyListingMenuItem.propTypes = {
  listing: propTypes.ownListing,
  busy: bool,
  menuItemClassName: string,
  testId: string,
  onCopy: func,
};

export default CopyListingMenuItem;
